import { Routes } from '@angular/router';
import { GESTAO_FINANCEIRA_ROUTES } from './gestao-financeira.constants';

const R = GESTAO_FINANCEIRA_ROUTES;

export const gestaoFinanceiraRoutes: Routes = [
    {
        path: R.ROOT,
        loadComponent: () => import('./gestao-financeira-content').then((m) => m.GestaoFinanceiraContent),
        data: { breadcrumb: 'Gestão Financeira' },
        children: [
            { path: '', redirectTo: R.DASHBOARD, pathMatch: 'full' },
            { path: R.DASHBOARD, loadComponent: () => import('./dashboard-painel/dashboard-painel').then((m) => m.DashboardPainel), data: { breadcrumb: 'Dashboard' } },
            {
                path: R.RECEBIDOS_SINTETICO,
                loadComponent: () => import('./recebidos-sintetico/recebidos-sintetico-painel').then((m) => m.RecebidosSinteticoPainel),
                data: { breadcrumb: 'Valores Recebidos Sintético' }
            },
            {
                path: R.RECEBIDOS_ANALITICO,
                loadComponent: () => import('./recebidos-analitico/recebidos-analitico-painel').then((m) => m.RecebidosAnaliticoPainel),
                data: { breadcrumb: 'Valores Recebidos Analítico' }
            },
            {
                path: R.INADIMPLENTES_SINTETICO,
                loadComponent: () => import('./inadimplentes-sintetico/inadimplentes-sintetico-painel').then((m) => m.InadimplSinteticoPainel),
                data: { breadcrumb: 'Inadimplentes Sintético' }
            },
            {
                path: R.INADIMPLENTES_ANALITICO,
                loadComponent: () => import('./inadimplentes-analitico/inadimplentes-analitico-painel').then((m) => m.InadimplentesAnaliticoPainel),
                data: { breadcrumb: 'Inadimplentes Analítico' }
            },
            { path: R.DIVIDA_ATIVA_SINTETICO, loadComponent: () => import('./divida-ativa/divida-ativa').then((m) => m.DividaAtiva), data: { breadcrumb: 'Dívida Ativa Sintético' } },
            {
                path: R.DIVIDA_ATIVA_ANALITICO,
                loadComponent: () => import('./divida-ativa-analitico/divida-ativa-analitico-painel').then((m) => m.DividaAtivaAnaliticoPainel),
                data: { breadcrumb: 'Dívida Ativa Analítico' }
            },
            {
                path: R.PANORAMA_CRM,
                loadComponent: () => import('./panorama-crm/panorama-crm').then((m) => m.PanoramaCrm),
                data: { breadcrumb: 'Panorama dos CRMs' }
            },
            {
                path: R.PESSOA,
                loadComponent: () => import('@/features/financeiro/arrecadacao/dashboard-arrecadacao/dashboard-arrecadacao').then((m) => m.DashboardArrecadacao),
                data: { breadcrumb: 'Pessoa' }
            }
        ]
    }
];
